/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Contactsupport1Inputs */

const en_btn_contactsupport1 = /** @type {(inputs: Btn_Contactsupport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact support`)
};

/**
* | output |
* | --- |
* | "Contact support" |
*
* @param {Btn_Contactsupport1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_contactsupport1 = /** @type {((inputs?: Btn_Contactsupport1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Contactsupport1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_contactsupport1(inputs)
});
export { btn_contactsupport1 as "btn_contactSupport" }